import { Vocabulary } from "../../Utils/Vocabulary";
import { Grid, Typography } from "@mui/material";
import ClientGeneralInfo from "./ClientGeneralInfo";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { getData } from "../../Services/getData";
import { endpoints } from "../../Utils/UrlEnum";
import { ClientModel } from "../../Utils/Models";

export default function Client() {
  const { id } = useParams();
  const [client, setClient] = useState<ClientModel>();

  /**
   * This useEffect hook runs when the 'id' dependency changes.
   * If 'id' is defined, it triggers the getClientById function to fetch client data by the given 'id'.
   */
  useEffect(() => {
    if (id) getClientById(id);
  }, [id]);

  /**
   *
   * @param id
   */
  const getClientById = (id: string) => {
    getData(`${endpoints.client.main}/${id}`).then((response) => {
      if (response?.data) setClient(response?.data);
    });
  };

  return (
    <div style={{ width: "100%", padding: 25 }}>
      <Grid container spacing={2} alignItems="baseline">
        <Grid item xs={12} sm={12} md={12} lg={11} xl={11}>
          <Typography variant="h4">{`${Vocabulary.client}:  ${
            client?._id ? client?.firstName : Vocabulary.newMasculine
          }`}</Typography>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <ClientGeneralInfo client={client} setClient={setClient} />
        </Grid>
      </Grid>
    </div>
  );
}
